<i18n
  src="@/locales/views/agro_exporter/quality_control/crop_field/new_inspection.yml"
  lang="yaml"
></i18n>
<i18n src="@/locales/models/quality_inspect.yml" lang="yaml"></i18n>
<template>
  <div>
    <go-back-link
      :text="$t('labels.go_back_link')"
      name="ae_quality_control_crop_field_list_quality_inspects_path"
      :params="{
        agro_exporter_id: agro_exporter_id,
        crop_field_id: crop_field_id,
        producer_id: producer_id,
        current_tab: current_tab,
      }"
    />

    <bread-crumbs
      :labels="[
        module_name,
        producer.name,
        crop_field.code,
        template?.name,
      ]"
    ></bread-crumbs>
    <template v-if="load_general_data">
      <crop-field-info :crop_field="crop_field" />
      <div class="mt-8">
        <div class="panel">
          <div class="panel-header">
            <h3 class="panel-header-title">
              {{ $t("labels.title") }}
            </h3>
          </div>

          <div class="panel-body">
            <div
              class="mt-6 grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6 w-full pb-6"
            >
              <div class="sm:col-span-3">
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.registered_at") }}
                </label>
                <div class="mt-1 relative rounded-md shadow-sm z-10">
                  <date-form
                    v-if="render_registered_at"
                    v-model="registered_at"
                    :first-day-of-week="2"
                    locale="es"
                    show-iso-weeknumbers
                    output-format="YYYY-MM-DD"
                  ></date-form>
                </div>
              </div>
              <div
                class="sm:col-span-3"
                v-if="
                  template &&
                  template?.use_samplings &&
                  !template?.specific_sampling
                "
              >
                <label
                  for="first-name"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.samplings") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model.lazy.number="samplings"
                    class="input-text"
                  />
                </div>
              </div>
              <div class="sm:col-span-3" >
                <label
                  for="inspect_code"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.inspect_code") }}
                </label>
                <div class="mt-1">
                  <input
                    type="text"
                    v-model="inspect_code"
                    class="input-text"
                  />
                </div>
              </div>
              <div class="sm:col-span-3"  v-if="inspectors.length > 0">
                <label
                  for="inspect_code"
                  class="block text-sm font-medium text-gray-700"
                >
                  {{ $t("model.quality_inspect.inspector") }}
                </label>
                <div class="mt-1">
                  <select-form
                    v-model="inspector_id"
                    :options="inspectors"
                  />
                </div>
              </div>
              <div class="sm:col-span-6">
                <label class="label-form">
                  {{ $t("model.quality_inspect.observations") }}
                </label>
                <div class="mt-1">
                  <textarea
                    v-model="observations"
                    rows="3"
                    class="input-text-area"
                  />
                </div>
              </div>
            </div>
            <template v-if="template">
              <sampling-layout
                v-if="template.use_samplings"
                v-model="quality_samplings"
                :samplings="samplings"
                :quality_template="template"
              />
              <general-layout
                v-else
                v-model="quality_generals"
                :quality_template="template"
              />
            </template>
          </div>
          <div class="panel-footer">
            <div class="panel-footer-actions">
              <white-button
                @click.prevent="gotToCropField()"
                :label="$t('labels.cancel_button')"
              />
              <span class="space-actions"></span>
              <success-button
                v-if="!proc_save_button"
                @click.prevent="submit()"
                :label="$t('labels.save_button')"
              />
              <success-button-processing
                v-else
                :label="$t('labels.save_button')"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
    <loading-message v-else />
  </div>
</template>

<script>
import Requester from "@/views/agro_exporter/requesters/quality_control/crop_field/new_inspection.js";
import CropFieldInfo from "@/components/views/agro_exporter/quality_control/crop_field/CropFieldInfo.vue";
import GoBackLink from "@/components/views/layout/GoBackLink";
import SamplingLayout from "@/components/views/layout/quality_control/SamplingLayout.vue";
import GeneralLayout from "@/components/views/layout/quality_control/GeneralLayout.vue";

import moment from "moment";
import BreadCrumbs from "@/components/views/layout/BreadCrumbs.vue";

export default {
  components: {
    CropFieldInfo,
    GoBackLink,
    BreadCrumbs,
    SamplingLayout,
    GeneralLayout,
  },
  props: {
    agro_exporter_id: { required: true },
    crop_field_id: {
      required: true,
    },
    quality_template_id: {
      required: true,
    },
    producer_quality_template_id: {
      required: true,
    },
    producer_id: {
      required: true,
    },
    current_tab: {},
  },
  data() {
    return {
      load_general_data: false,
      proc_save_button: false,
      render_registered_at: false,
      producer: {},
      crop_field: {},
      template: null,
      samplings: null,
      registered_at: null,
      observations: null,
      inspect_code: null,
      inspector_id: null,
      quality_generals: [],
      quality_samplings: [],
      inspectors: [],
    };
  },
  computed: {
    can_send: function () {
      return this.valid_data && !this.proc_save_button && this.template;
    },
    registered_at_formatted: function () {
      return moment(this.registered_at).format("YYYY-MM-DD");
    },
    save_link_class: function () {
      let basic_class = "btn-main";
      if (this.can_send) return basic_class;
      return `${basic_class}  opacity-50 cursor-not-allowed`;
    },
    valid_data: function () {
      return (
        Boolean(this.registered_at) &&
        (Boolean(this.samplings) || !this.template?.use_samplings)
      );
    },
  },
  created() {
    this.checkIfAuthenticated().then(() =>
      this.checkIfAuthorized({
        role: this.$route.meta.role,
        permission: this.$route.meta.permission,
        entity: {
          agro_exporter_id: this.agro_exporter_id,
        },
      }).then(() => {
        this.fetchData();
      })
    );
  },
  methods: {
    fetchData: async function () {
      //await this.fetchProducer();
      await this.fetchCropField();
      await this.fetchInspectors();
      await this.fetchTemplate();
      this.registered_at = moment(this.crop_field.load_date).format("YYYY-MM-DD");
      this.render_registered_at = true;
      this.load_general_data = true;
    },
    fetchProducer: async function () {
      let response = await Requester.fetchProducer(
        this.agro_exporter_id
      );
      this.producer = response.data;
    },
    fetchInspectors: async function () {
      let response = await Requester.fetchInspectors(this.agro_exporter_id);
      this.inspectors = response.data;
      const user_connected = this.$store.state.authentication.user_connected_id;
      if (this.inspectors.some((inspector) => inspector.id == user_connected)) {
        this.inspector_id = parseInt(user_connected);
      }
    },
    fetchCropField: async function () {
      let response = await Requester.fetchCropField(
        this.agro_exporter_id,
        this.crop_field_id
      );
      this.crop_field = response.data;
    },
    fetchTemplate: async function () {
      let response = await Requester.fetchTemplate({
        agro_exporter_id: this.agro_exporter_id,
        crop_field_id: this.crop_field_id,
        quality_template_id: this.quality_template_id,
      });
      this.template = response.data;
      this.samplings = this.template?.samplings;
    },
    gotToCropField: function () {
      this.$router.push({
        name: "ae_quality_control_crop_field_list_quality_inspects_path",
        params: {
          agro_exporter_id: this.agro_exporter_id,
          crop_field_id: this.crop_field_id,
          producer_id: this.producer_id,
          producer_quality_template_id:
            this.producer_quality_template_id,
        },
      });
    },
    submit: async function () {
      if (!this.can_send) return;
      this.proc_save_button = true;
      if (this.template?.use_samplings) await this.submit_with_samplings();
      else await this.submit_without_samplings();
      this.proc_save_button = false;
    },
    submit_with_samplings: async function () {
      try {
        let response = await Requester.createWithSamplings({
          agro_exporter_id: this.agro_exporter_id,
          crop_field_id: this.crop_field_id,
          quality_template_id: this.quality_template_id,
          registered_at: this.registered_at_formatted,
          samplings: this.samplings,
          inspect_code: this.inspect_code,
          inspector_id: this.inspector_id,
          observations: this.observations,
          quality_samplings: this.quality_samplings,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.gotToCropField();
      } catch (error) {
        console.log(error);
      }
    },
    submit_without_samplings: async function () {
      try {
        let response = await Requester.createWithoutSamplings({
          agro_exporter_id: this.agro_exporter_id,
          crop_field_id: this.crop_field_id,
          quality_template_id: this.quality_template_id,
          registered_at: this.registered_at_formatted,
          inspector_id: this.inspector_id,
          observations: this.observations,
          inspect_code: this.inspect_code,
          quality_generals: this.quality_generals,
        });
        this.registerSuccessNotification({
          title: response.data.success_message,
        });
        this.gotToCropField();
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>
